import { find } from '../helpers';

const element = find('[data-content-block]')

if (element) {
    import('./index')
}
